import Contact from "../pages/institutional/Contact";
import Exchanges from "../pages/institutional/Exchanges";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductDetailPage from "../pages/product/page";
import CheckoutPage from "../pages/checkout/page";

const routes: RouteObject[] = [
  {path:"/contato", element:<Contact />},
  {path:"/politica-de-trocas", element:<Exchanges />},
  {path:"/trocas-e-devolucoes", element:<Exchanges />},
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/produto/:id",
    element: <ProductDetailPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;